import { proxyClientInstance } from "../../wrappers/client";

export const getFacultyContacts = (personId) => {
  const getUrl = `/api/contacts/v1/emails?linkId=${personId}`;
  return proxyClientInstance.get(getUrl);
};